import React from "react";
import '../styles/project.css';
import { useLocation } from "react-router-dom";
import Tree from "./tree";


export default function Project() {

    const location = useLocation();
    const data = location.state.data
    const images = data.pics

    console.log(data)

    const openImage = (image) => {
        window.open(image, '_blank').focus();
    }

    return (
        <div class="project-container">
            <div class="img-container">
                {images.map(
                    image => 
                    <img class="img" src={image} alt="not found" onClick={() => openImage(image)}/>
                )}
            </div>
            <h2 class="project-title">Project</h2>
            <text class="project-text">
                This is a project page, where you can put your description of the project. 
                You can also add some images to the page to make it look better.
            </text>
            <Tree/>
            <Tree inverted={true}/>
        </div>
    )
}